function ApplicationStatus({ status }) {

    const styles = {
        status: {
            padding: "5px 10px",
            borderRadius: "5px",
            /*position: "relative",
            top: "5px"*/
        }
    };

    return (
        <>
            { status == "applied" ? (
                <span className="bg-primary text-white"
                    style={ styles.status }>Applied</span>

            ) : status == "in_review" ? (
                <span className="bg-warning"
                    style={ styles.status }>In-review</span>

            ) : status == "shortlisted" ? (
                <span className="bg-primary text-white"
                    style={ styles.status }>Shortlisted</span>

            ) : status == "interviewing" ? (
                <span className="bg-info text-white"
                    style={ styles.status }>Interviewing</span>

            ) : status == "accepted" ? (
                <span className="bg-success text-white"
                    style={ styles.status }>Accepted</span>

            ) : status == "not_considered" && (
                <span className="bg-danger text-white"
                    style={ styles.status }>Not Considered</span>
            ) }
        </>
    );
}

export default ApplicationStatus;